import { render } from "./WorkFlowBuilder.vue?vue&type=template&id=5379ba84&scoped=true"
import script from "./WorkFlowBuilder.vue?vue&type=script&lang=js"
export * from "./WorkFlowBuilder.vue?vue&type=script&lang=js"

import "./WorkFlowBuilder.vue?vue&type=style&index=0&id=5379ba84&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5379ba84"]])

export default __exports__